import { render, staticRenderFns } from "./TrialsSummary.vue?vue&type=template&id=018381a8&"
import script from "./TrialsSummary.vue?vue&type=script&lang=js&"
export * from "./TrialsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports